"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _randomId = _interopRequireDefault(require("../../utils/randomId"));
var _Label = _interopRequireDefault(require("../Label"));
var _excluded = ["className", "theme", "testId", "label", "required", "children", "childProps", "errors"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var defaultProps = {
  theme: {
    Label: {}
  }
};

/**
 * Form Component handles layout
 */
var FormComponent = exports["default"] = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(FormComponent, _React$Component);
  function FormComponent(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, FormComponent);
    _this = _callSuper(this, FormComponent, [props]);
    _this.idSuffix = (0, _randomId["default"])();
    return _this;
  }
  (0, _createClass2["default"])(FormComponent, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        className = _this$props.className,
        theme = _this$props.theme,
        testId = _this$props.testId,
        label = _this$props.label,
        required = _this$props.required,
        children = _this$props.children,
        childProps = _this$props.childProps,
        errors = _this$props.errors,
        props = (0, _objectWithoutProperties2["default"])(_this$props, _excluded);
      var componentClassName = children.props.className ? "".concat(children.props.className, " ").concat(theme.children) : theme.children;
      var componentErrors = errors ? Object.keys(errors) : [];
      // Use provided id from childProps if available, otherwise use randomized idSuffix
      var componentErrorsId = childProps.id ? "".concat(childProps.id, "-errors") : "".concat(childProps.name, "-").concat(this.idSuffix, "-errors");
      var describedBy = children.props['aria-describedby'] || undefined;
      // If there are errors, add the errors ID to an existing aria-describedby, if applicable, or just set it as the sole aria-describedby
      if (componentErrors.length) {
        describedBy = describedBy ? "".concat(describedBy, " ").concat(componentErrorsId) : componentErrorsId;
      }
      return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
        className: (0, _classnames["default"])(className, theme.formComponent),
        "data-test-id": testId,
        "data-anypoint-component": "FormComponent",
        "data-anypoint-form-component": children.type.displayName
      }, props), label ? /*#__PURE__*/_react["default"].createElement(_Label["default"], {
        className: (0, _classnames["default"])(theme.label, required ? theme.required : theme.optional),
        htmlFor: childProps.id,
        theme: theme.LabelTheme
      }, label) : null, /*#__PURE__*/_react["default"].createElement("div", {
        className: theme.component
      }, children && /*#__PURE__*/_react["default"].cloneElement(children, _objectSpread(_objectSpread({}, childProps), {}, {
        'className': componentClassName,
        'aria-describedby': describedBy
      })), componentErrors.length ? /*#__PURE__*/_react["default"].createElement("ul", {
        id: componentErrorsId,
        className: theme.validationErrors,
        "aria-live": "polite"
      }, componentErrors.map(function (key) {
        return /*#__PURE__*/_react["default"].createElement("li", {
          key: key
        }, errors[key]);
      })) : null));
    }
  }]);
  return FormComponent;
}(_react["default"].Component);
(0, _defineProperty2["default"])(FormComponent, "defaultProps", defaultProps);
//# sourceMappingURL=FormComponent.js.map